/*
 * Die Rückfrage der Adressliste vor dem Umhängen des Standards (Entscheid 685, Hausregel „Bestätigung vor
 * Datenänderung“) — in der Form von „Hauptansprechpartner wechseln“ (`KundeAnsprechpartner.tsx`): wer es wird und wer es
 * danach nicht mehr ist. Schlüssel englisch, Werte deutsch (Hausregel „Texte in Properties“).
 */
export const ADDRESS_TEXT = {
  primaryTitle: "Standard wechseln?",
  primaryText: (neu: string, rolle: string, bisher: string | null): string => bisher === null
    ? `${neu} wird Standard für ${rolle}.`
    : `${neu} wird Standard für ${rolle} — ${bisher} ist es danach nicht mehr.`,
  // Das Wort der Aktion wie beim Hauptansprechpartner („Umhängen“, Review H3).
  primary: "Umhängen",
};
